export default __webpack_public_path__ + "media/color/lrc-28976950.svg";